import React, {Component} from 'react';
import {connect} from 'react-redux';
import PlayersListFactory from './factory';

class PlayersList extends Component {
    render() {
        const {sportConfig} = this.props;

        const PlayersList = PlayersListFactory.getComponent(sportConfig);

        return <PlayersList />;
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(PlayersList);
